import { Outlet } from "react-router";

import { ProtectedAdminRoute } from "@/components/auth/protected-admin-route";
import { AdminSidebar } from "@/components/layout/admin-sidebar";

export function AdminLayout() {
  return (
    <div className="flex min-h-full w-full flex-col">
      <ProtectedAdminRoute>
        <div className="flex min-h-dvh w-full bg-[#0b1628] text-white">
          <AdminSidebar />
          <main className="min-w-0 flex-1 overflow-auto bg-[#0c1b2e]">
            <Outlet />
          </main>
        </div>
      </ProtectedAdminRoute>
    </div>
  );
}
